const resubscribeTypes = {
  resub3month: 'resub3month',
  resub5month: 'resub5month',
  resub25: 'resub25',
  resub50: 'resub50',
  resubfree: 'resubfree',
  resubcard: 'resubcard',
  resubnew: 'resubnew',
  resub10reason: 'resub10reason',
  resub5month12: 'resub5month12',
  resub5month1350: 'resub5month1350',
}


export default resubscribeTypes
